export default __webpack_public_path__ + "static/media/stockMar.a62e825c.png";